import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'skeleton', 'container']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "skeleton" | "container")[]
 * }>} UgcBlockStyles
 */
export const ugcBlockStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.UgcBlock} args.component - UgcBlock component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   * @param {boolean} [args.isReady] - Whether Pixlee widget is ready
   *
   * @returns {UgcBlockStyles} - Component styles
   */
  baseStyle: ({isReady = false}) => {
    return {
      root: {
        width: '100%',
        minHeight: '400px',
        position: 'relative',
      },
      skeleton: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '400px',
        opacity: isReady ? 0 : 1,
        transition: 'opacity 0.3s ease-in-out',
        pointerEvents: isReady ? 'none' : 'auto',
      },
      container: {
        opacity: isReady ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        width: '100%',
        // Pixlee widget iframe styles
        sx: {
          iframe: {
            maxWidth: '100%',
            width: '100% !important',
          },
        },
      },
    };
  },
});
